import { Box, Chip } from '@mui/material'

type Props = {
  value: string[] | null | undefined
  row: { type: string }
}
export const ProductCell = ({ value, row }: Props) => {
  if (row.type !== 'marketplace' || !value || value.length === 0) {
    return null
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        gap: 0.5,
        flexWrap: 'wrap',
      }}
    >
      {value.map(subtype => (
        <Chip
          key={subtype}
          label={subtype === 'pv' ? 'Photovoltaic' : 'Heatpump'}
          size="small"
          sx={
            subtype === 'pv'
              ? { bgcolor: '#FFE0B2', color: '#E65100' }
              : { bgcolor: '#C8E6C9', color: '#2E7D32' }
          }
        />
      ))}
    </Box>
  )
}
